// extracted by mini-css-extract-plugin
export default {"container":"LoginPolicy_container__4yzwY","button":"LoginPolicy_button__pxSu8"};